// React import
import * as React from 'react';
// Standard layout imports
import Label from 'src/components/FormElements/Label';
import { ISubActivityModel } from 'src/Entities/Activity/Activity';
import Box from 'src/components/Box';
import Line from 'src/components/Line';
import { format, compareAsc } from 'date-fns';
import mapMarker from 'src/images/map_marker.png';
import { stringify } from 'querystring';
import { IActivityModel } from 'src/Entities/Activity/Activity';

interface IProps {
  activityModel: IActivityModel;
}

function formatFiuNo(fiuNo: string) {
  const seperator = '-';
  const formattedNo = [
    fiuNo.slice(0, 4),
    seperator,
    fiuNo.slice(4, 6),
    seperator,
    fiuNo.slice(6, 8),
    seperator,
    fiuNo.slice(8, 10)
  ].join('');
  return formattedNo;
}

const SubActivitiesComponentOtherInfo = ({ activityModel }: IProps) => {
  return (
    <Box>
      <div className="f4">
        <Label className="fw9 has-text-black">FIU-NUMMER</Label>
        <p className="fw6 mb0 has-text-gray-900">
          {formatFiuNo(activityModel.fiuNo)}
        </p>
      </div>
      {activityModel.contactInfoName ? (
        <div>
          <div className="border-b-4 border-gray-body pb-4 mb-2" />
          <div className="f4">
            <Label className="fw9 has-text-black">
              FOR YDERLIGERE OPLYSNINGER
            </Label>
            <div className="fw6 has-text-gray-900">
              {activityModel.contactInfoName}
              <br />
              {activityModel.contactInfoPhone === null || undefined ? (
                ''
              ) : (
                <div>
                  +45{activityModel.contactInfoPhone} <br />
                </div>
              )}
              {activityModel.contactInfoMail === null || undefined ? (
                ''
              ) : (
                <a
                  className="has-text-gray-900"
                  href={`mailto:${activityModel.contactInfoMail}`}
                >
                  {activityModel.contactInfoMail}
                </a>
              )}
            </div>
          </div>
        </div>
      ) : (
        ' '
      )}
    </Box>
  );
};

export default SubActivitiesComponentOtherInfo;



// WEBPACK FOOTER //
// ./src/Pages/CoursePortal/Activityies/Activity/subActivities.componentOtherInfo.tsx